module.exports = __webpack_public_path__ + "public/assets/img/login-v2.72cd8a26.svg";